export const STATUS_REGISTERED = 'registered'
export const STATUS_VERIFIED = 'verified'
export const STATUS_SUSPENDED = 'suspended'